import { ServiceHookFactory } from "@rsm-hcd/javascript-react";
import PageEditSessionRecord from "models/view-models/page-edit-session-record";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";

export interface PageEditSessionGetParams {
    id: number;
}
export interface PageEditSessionActiveGetParams {
    pageId: number;
}
export interface PageEditSessionCreateParams {
    pageId: number;
    blockId?: number;
}
const baseEndpoint = "page-edit-sessions";
const resourceEndpoint = `${baseEndpoint}/:id`;
const createEndpoint = `${baseEndpoint}/start-editing`;
const activeSessionEndpoint = `${baseEndpoint}/active`;
const resourceType = PageEditSessionRecord;
const key = "page-edit-session";

export const PageEditSessionService = {
    useCreate: ServiceHookFactory.useNestedCreate<
        PageEditSessionRecord,
        PageEditSessionCreateParams
    >(resourceType, createEndpoint),
    useDelete: ServiceHookFactory.useDelete(resourceEndpoint),
    useGetQuery: QueryHookFactory.useGetQuery<
        PageEditSessionRecord,
        PageEditSessionGetParams
    >(key, PageEditSessionRecord, resourceEndpoint),
    useGetActiveSessionQuery: QueryHookFactory.useGetQuery<
        PageEditSessionRecord,
        undefined,
        PageEditSessionActiveGetParams
    >(key, PageEditSessionRecord, activeSessionEndpoint),
};
